import { useState } from 'react'
import ItemTabs from 'components/ItemTabs'
import AccessLevels from './AccessLevels'
import ChangePassword from './ChangePassword'
import { Container } from '../styles'

export default function EditSecurity () {
  const [option, setOption] = useState ('access_levels')

  const OPTION_LIST = [
    {label: 'Níveis de acesso', value: 'access_levels', component: <AccessLevels/>},
    {label: 'Alterar senha', value: 'change_password', component: <ChangePassword/>}
  ]

  return (
    <Container style={{paddingTop: 0}}>
      <ItemTabs
        tabs={OPTION_LIST}
        selectedTab={option}
        onTabChange={setOption}
        containerStyle={{paddingTop: 7}}
        tabWidth={150}
      />
      {OPTION_LIST.find (o => o.value === option).component}
    </Container>
  )
}
